import { useAbility } from '@casl/vue'
import { getCurrentInstance } from 'vue'
import { canViewNavMenuGroup as enhancedCanViewNavMenuGroup } from '@/utils/navigation-helpers'

/**
 * Returns ability result if ACL is configured or else just return true
 * We should allow passing string | undefined to can because for admin ability we omit defining action & subject
 *
 * Useful if you don't know if ACL is configured or not
 * Used in @core files to handle absence of ACL without errors
 *
 * @param {string} action CASL Actions // https://casl.js.org/v4/en/guide/intro#basics
 * @param {string} subject CASL Subject // https://casl.js.org/v4/en/guide/intro#basics
 */
export const can = (action, subject) => {
  const vm = getCurrentInstance()
  if (!vm)
    return false
  const localCan = vm.proxy && '$can' in vm.proxy
  
  if (!localCan) {
    return true
  }
  
  // Simple direct permission check - let the backend handle all permission logic
  return vm.proxy?.$can(action, subject)
}

/**
 * Check if user can view item based on it's ability
 * Based on item's action and subject & Hide group if all of it's children are hidden
 * @param {object} item navigation object item
 */
export const canViewNavMenuGroup = item => {
  // Use enhanced navigation helper that supports team-specific permissions
  return enhancedCanViewNavMenuGroup(item)
}
export const canNavigate = to => {
  const ability = useAbility()

  // Get the most specific route (last one in the matched array)
  const targetRoute = to.matched[to.matched.length - 1]

  // If the target route has specific permissions, check those first
  if (targetRoute?.meta?.action && targetRoute?.meta?.subject) {
    return ability.can(targetRoute.meta.action, targetRoute.meta.subject)
  }

  // If no specific permissions, fall back to checking if any parent route allows access
  return to.matched.some(route => {
    const action = route.meta.action
    const subject = route.meta.subject
    
    if (!action || !subject) return false
    
    return ability.can(action, subject)
  })
}
